import * as React from 'react';
import { NavigatorV3 as NavigatorV3Memoized } from '../../../../../Navigator/NavigatorV3.js';
import { useNavigationButton } from './hooks/useNavigationButton.js';

var NavigationButton = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useNavigationButton = useNavigationButton(props, ref),
    navigatorProps = _useNavigationButton.navigatorProps;
  return /*#__PURE__*/React.createElement(NavigatorV3Memoized, navigatorProps);
});
NavigationButton.displayName = 'NavigationButton';

export { NavigationButton };
//# sourceMappingURL=NavigationButton.js.map
